import { GET_APPROVERS_REQUEST, GET_APPROVERS_SUCCESS, GET_APPROVERS_FAILURE, GET_APPROVERS_RESET, } from "../../actions";
const initialState = {
    data: null,
    loading: false,
    error: null,
};
const getApproversReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_APPROVERS_REQUEST:
            return Object.assign(Object.assign({}, state), { loading: true, error: null });
        case GET_APPROVERS_SUCCESS:
            return Object.assign(Object.assign({}, state), { loading: false, error: null, data: action.payload });
        case GET_APPROVERS_FAILURE:
            return Object.assign(Object.assign({}, state), { loading: false, error: action.payload, data: null });
        case GET_APPROVERS_RESET:
            return Object.assign(Object.assign({}, state), { loading: false, data: null, error: null });
        default:
            return state;
    }
};
export default getApproversReducer;
